import { render } from "./StockMovementsView.vue?vue&type=template&id=54faa7de"
import script from "./StockMovementsView.vue?vue&type=script&lang=js"
export * from "./StockMovementsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__